module.exports = __webpack_public_path__ + "img/main_img1.97f7a08e.png";